import React from 'react'
import CommonDepositForm from './CommonDepositForm'

const CheckForm = (props) => {
  return <CommonDepositForm {...props} showBankAccountField={false} showDepositToCashOption={true} showTransferMessage={false} />
}

export default CheckForm
